export type SeasonName = 'gregorian' | 'hijri'

export interface Season {
  name: SeasonName
  // The year being welcomed, e.g. 2027 or 1449.
  year: number
}

// The active seasonal theme, or null. The site is statically generated, so this is always null in
// the built HTML; app.vue fills it in on the client from the visitor's clock (resolveSeason), and
// an inline <head> script has already set data-season by then, so the colours never flash.
export function useSeason() {
  return useState<Season | null>('season', () => null)
}
